/** Mask tokens — each stands for one typed character; anything else is a literal. */
const MASK_TOKENS: Record<string, RegExp> = {
  "#": /\d/u,
  A: /\p{L}/u,
  "*": /[\p{L}\d]/u,
};

function tokensIn(pattern: string): RegExp[] {
  return [...new Set([...pattern])]
    .map((char) => MASK_TOKENS[char])
    .filter((token): token is RegExp => token != null);
}

/** True when every token in the pattern accepts digits only. */
export function isDigitMask(pattern: string): boolean {
  const chars = [...pattern];
  return chars.includes("#") && chars.every((char) => char === "#" || MASK_TOKENS[char] == null);
}

/**
 * Applies `pattern` to `value`, inserting literals as the user types. Literals
 * are stripped and re-inserted on every pass rather than preserved, so the mask
 * is idempotent and backspacing across a separator deletes the character before
 * it. A trailing literal is only appended once a character follows it.
 */
export function applyMask(value: string, pattern: string): string {
  const tokens = tokensIn(pattern);
  if (tokens.length === 0) return value;

  const source = [...value].filter((char) => tokens.some((token) => token.test(char)));

  let result = "";
  let index = 0;

  for (const patternChar of pattern) {
    const token = MASK_TOKENS[patternChar];
    if (token) {
      while (index < source.length && !token.test(source[index]!)) index++;
      if (index >= source.length) break;
      result += source[index++];
    } else {
      if (index >= source.length) break;
      result += patternChar;
    }
  }

  return result;
}
